import React from "react";
import * as FaIcons from "react-icons/fa";
import { MdLink } from "react-icons/md";

const LinkItem = ({ link }) => {
  const getMatchedIcon = (name) => {
    const lowerName = name?.toLowerCase();

    for (const iconName in FaIcons) {
      const strippedIconName = iconName.replace(/^Fa/, "").toLowerCase();
      if (lowerName.includes(strippedIconName)) {
        const IconComponent = FaIcons[iconName];
        return <IconComponent />;
      }
    }
    return <MdLink />;
  };

  return (
    <div className="p-2 bg-white rounded-lg mb-2 shadow-lg hover:shadow-xl transition-all duration-300 ease-in-out transform hover:scale-105 hover:bg-gray-50">
      <a
        href={link.url}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center text-gray-800 hover:text-gray-900 transition-colors duration-200 no-underline"
      >
        <span className="mr-4 text-2xl text-blue-500">
          {getMatchedIcon(link.label)}
        </span>
        <span className="font-semibold text-lg">{link.label}</span>
      </a>
    </div>
  );
};

export default LinkItem;
